import { useCallback, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../../helpers";

const RESIZE_HANDLE_WIDTH = 6;
const CURSOR = "col-resize";

export const ResizeHandle = observer(function ResizeHandle() {
  const { tarsAnalyticsStore } = useStore();
  const isDragging = useRef(false);
  const startX = useRef(0);
  const startWidth = useRef(0);

  const onMouseMove = useCallback(
    (e: MouseEvent) => {
      if (!isDragging.current) return;
      const delta = startX.current - e.clientX;
      tarsAnalyticsStore.setCanvasPaneWidth(startWidth.current + delta);
    },
    [tarsAnalyticsStore]
  );

  const onMouseUp = useCallback(() => {
    if (!isDragging.current) return;
    isDragging.current = false;
    document.body.style.cursor = "";
    document.body.style.userSelect = "";
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  }, [onMouseMove]);

  useEffect(() => () => {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  }, [onMouseMove]);

  const handleMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      isDragging.current = true;
      startX.current = e.clientX;
      startWidth.current = tarsAnalyticsStore.canvasPaneWidth;
      document.body.style.cursor = CURSOR;
      document.body.style.userSelect = "none";
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
    [tarsAnalyticsStore.canvasPaneWidth, onMouseMove, onMouseUp]
  );

  return (
    <div
      role="separator"
      aria-label="Resize canvas pane"
      className="shrink-0 cursor-col-resize bg-gray-100 hover:bg-[#7C3AED] hover:bg-opacity-20 active:bg-[#7C3AED] active:bg-opacity-30 transition-colors flex flex-col justify-center items-center group"
      style={{ width: RESIZE_HANDLE_WIDTH, minWidth: RESIZE_HANDLE_WIDTH }}
      onMouseDown={handleMouseDown}
    >
      <div
        className="w-0.5 h-8 rounded-full bg-gray-300 group-hover:bg-[#7C3AED] group-active:bg-[#7C3AED] opacity-60"
        aria-hidden
      />
    </div>
  );
});
